import { Link } from "react-router-dom";
import HotRankList from "@/components/feature/HotRankList";
import { hotList } from "@/mocks/site";
import type { Article } from "@/types/content";

interface HotBoardProps {
  articles: Article[];
}

export default function HotBoard({ articles }: HotBoardProps) {
  const headlines = articles.slice(0, 5);

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <section className="lg:col-span-2">
        <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="mb-2 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line w-5 h-5 flex items-center justify-center"></i>
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">实时热搜榜</h2>
            </div>
            <Link
              to="/rankings"
              className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              完整榜单
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </Link>
          </div>
          <p className="mb-3 text-xs text-foreground-500">按实时讨论量排序 · 每 10 分钟刷新一次</p>
          <HotRankList items={hotList} limit={10} />
        </div>
      </section>

      <aside className="flex flex-col gap-6">
        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
              <i className="ri-live-line w-4 h-4 flex items-center justify-center"></i>
            </span>
            <h2 className="font-heading text-base font-bold text-foreground-950">今日快讯</h2>
          </div>
          <ul className="space-y-3">
            {headlines.map((item, index) => (
              <li key={item.id}>
                <Link to={`/article/${item.id}`} className="group flex gap-3">
                  <span className="mt-0.5 shrink-0 font-heading text-sm font-bold text-primary-400">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-700 group-hover:text-primary-700">
                    {item.title}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-pushpin-2-line w-4 h-4 flex items-center justify-center"></i>
            </span>
            <h2 className="font-heading text-base font-bold text-secondary-900">编辑推荐</h2>
          </div>
          <p className="text-sm leading-relaxed text-secondary-800">
            想看更有信息量的复盘？我们把近期讨论度最高的话题做成了专题，包含事件脉络、网友观点与后续进展。
          </p>
          <Link
            to="/articles"
            className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            进入资讯列表
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </span>
          </Link>
        </div>
      </aside>
    </div>
  );
}